<template>
    <div>
        <NavComponent :index="4"></NavComponent>
        <SideBarComponent></SideBarComponent>
        <div>
            <div class="banner" v-bind:style="{backgroundImage:'url(https://cdn.hanlandglobal.com/hanland-about-banner.jpg)'}">

            </div>
            <div class="content-container main">
                <div class="main-left">
                    <img class="main-img" src="https://cdn.hanlandglobal.com/about-img.jpg"/>
                </div>
                <div class="main-right">
                    <div class="title">
                        <h3>公司介绍</h3>
                        <div>
                            <span>ABOUT</span>
                            <i>US</i>
                        </div>
                    </div>
                    <div class="line"></div>
                    <p>汉伦拥有10余年丰富的英国本土房地产市场投资背景，全方位无缝对接当地资源，作为连接中英房地产投资咨询领域的桥梁，汉伦专注于英国房地产置业投资咨询，专业物业管理服务及优质特色的中英教育交流。我们在英国的业务运营以曼彻斯特为中心，并辐射伦敦、剑桥，牛津、谢菲尔德、利物浦、诺丁汉、伯明翰、利兹、莱斯特等主要城市。</p>
                </div>
            </div>
            <div class="content-container main-bottom">
                <div class="left">
                    <h3>房产方面</h3>
                    <p>根据客户需求我们提供全方位一体化的专属定制服务，稳定保障客户的投资回报率，同时提供一站式物业管理服务，为客户解决全屋家具定制，房屋日常维护等难题，精细化服务只为想客户所想，让客户做省心洋房东。</p>
                </div>
                <div class="right">
                    <h3>教育方面</h3>
                    <p>主要致力于开创游有所获的浸入式英国游学和专业的个性化订制课程，我们与牛津、剑桥、曼切斯特大学等世界名校达成长期合作，消除中间环节，直接提供最国际化的特色项目。</p>
                </div>
            </div>
        </div>
        <FooterComponent></FooterComponent>
    </div>
</template>
<script>
import FooterComponent  from '@components/FooterComponent'
import NavComponent  from '@components/NavComponent'
import SideBarComponent from '@components/SideBarComponent'

export default {
    name: 'AboutUs',
    computed:{

    },
    components: {
        FooterComponent,
        NavComponent,
        SideBarComponent,
    },
    data(){
        return {

        }
    },
    mounted(){

    },
    methods:{

    }

}
</script>
<style lang="scss" scoped>
.banner{
    width: 100%;
    height: 20.8rem;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 20.8rem;  
}
.main{
    height: 24rem;
}
.main-left{
    position:absolute;
}
.main-right{
    float: right;
    width: 35rem;
    .title{
        display: flex;
        margin-top:5rem;
        span{
            display: block;
            font-size: 0.8rem;
            color: #868f99;
            font-weight: 700;
        }
        i{
            display: block;
            color: #868f99;
            font-size: 0.7rem;
        }
        div{
            margin:0.2rem 0 0 0.7rem;
        }
    }
    h3{
        font-size: 1.6rem;
        letter-spacing: 2px;
        color: $color;
    }
    p{
        font-size: 1rem;
        line-height: 2rem;
        color: #3a4a5b;
    }
    .line{
        width: 1.4rem;
        border-bottom: solid 0.2rem #a22915;
        margin:1.2rem 0 2.4rem;
    }
}
.main-img{
    width: 18.6rem;
    height: 24rem;
    display: block;
    position: absolute;
    z-index: 999;
    top:-2rem;
}
.main-bottom{
    display: flex;
    justify-content: space-between;
    margin:2rem auto 5rem;
    color: #fff;
    div{
        width: 28.5rem;
        height: 14.8rem;
    }
    .left{
        background: url("../assets/image/about/bg-img1.jpg") no-repeat center;
        background-size:28.5rem 14.8rem;
    }
    .right{
        background: url("../assets/image/about/bg-img2.jpg") no-repeat center;
        background-size:28.5rem 14.8rem;
    }
    h3{
        text-align: center;
        font-size: 1.5rem;
        line-height: 3.8rem;
        letter-spacing: 2px;
        color: #ffffff;
    }
    p{
        width:21rem;
        font-size: 1rem;
        line-height: 1.8rem;
        margin: 0 auto;
    }
}
@media only screen and (max-width: 1024px){
    .banner{
        height: 18.8rem;
        background-size: cover;
    }
    .main{
        width: 94%;
        height: auto;
        margin: 0 auto;
    }
    .main-img{
        width: 12.6rem;
        height: 18rem;
        display: none;
    }
    .main-right{
        .title{
            margin-top: 3rem;
        }
        .line{
            margin: 1.2rem 0 1.6rem;
        }
        p{

        }
    }
    .main-bottom{
        display: block;
        .left{
            margin: 0 auto;
        }
        .right{
            margin: 2rem auto 0;
        }
    }
}
</style>